
function Footer() {
  return (
    <div className="main-footer pb-0 bg-gradient-dark">
      <div className="d-flex justify-content-between">
      <p className="text-bold ">Copyright &copy; 2019 <a href="https://svsinfotech.in/" className="text-blue" target="blank">SVS infotech.in</a></p>
      <p>All rights reserved</p>
      </div>
    </div>
  );
}
export default Footer;
